import { render, staticRenderFns } from "./licenseSettings.vue?vue&type=template&id=664aad80"
import script from "./licenseSettings.vue?vue&type=script&lang=js"
export * from "./licenseSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports